import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Card } from 'reactstrap';
import Page from '~/components/page/page';
import TitleBar from '~/components/titleBar/titleBar';
import { actions as BreweryActions } from '~/redux/brewery';

export class SelectBreweryPage extends Component {
  navigateToBrewery = brewery => {
    this.props.setBrewery(brewery);
    this.props.history.push(`/`);
  };

  render() {
    return (
      <Page hideSideNav>
        <TitleBar className="tc" title="Which brewery are you after?" />
        <div className="content flex justify-center">
          {this.props.breweries.map(brewery => {
            return (
              <div key={brewery.id}>
                <Card onClick={() => this.navigateToBrewery(brewery)} className="mh4 pointer flex w5 tc pa4">
                  <h3 className="ma0">{brewery.name}</h3>
                </Card>
              </div>
            );
          })}
        </div>
      </Page>
    );
  }
}

function mapStateToProps(state) {
  return {
    breweries: state.breweries
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      setBrewery: BreweryActions.setBrewery
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(SelectBreweryPage));



// WEBPACK FOOTER //
// ./src/pages/selectBrewery/selectBrewery.jsx